module.exports = __webpack_public_path__ + "img/demo-scrollfollow.656ed05b.gif";